export default __webpack_public_path__ + "static/media/Dispatch-inactive-icons.9e5ffdc5.svg";